export interface FavoriteDto{
    entity: FavoriteEntityType,
    entityId: string,
    state: boolean
}

export enum FavoriteEntityType{
    Channel
}
